<div *ngIf="isLoading" class="loading">
    <nz-spin class="spin" nzSimple [nzSize]="'large'"> </nz-spin>
</div>
